import appVersionReducer from './services/app/appVersionReducer'

const reducers = {
  version: appVersionReducer,
}

export default reducers
